module.exports = __webpack_public_path__ + "static/media/logo.ad62c441.png";